<template>
  <el-config-provider :locale="locale">
    <router-view/>
  </el-config-provider>
</template>
<script>
   //import { ElConfigProvider } from 'element-plus'
   import { createApp } from 'vue';
   import App from './App.vue';

   import zhCn from 'element-plus/lib/locale/lang/zh-cn'
   export default {
     setup() {
       const app = createApp(App);
       app.directive('premission', (el, binding, vnode) => {
         console.log(el,123);
       })
      return{
        locale: zhCn,
      }
     }
   }

  // export default {
  //   name: 'app',
  //   // components: {
  //   //   [ElConfigProvider.name]: ElConfigProvider,
  //   // },
  //   data() {
  //     return {
  //      locale: zhCn,
  //     }
  //   },
  //   mounted() {
  //     const app = createApp(App);
  //     app.directive('premission', (el, binding, vnode) => {
  //       console.log(el);
  //     })
  //   },
  // }
</script>
<style lang="less" src="../static/plugin/index.less"></style>
<style lang="less" src="../static/plugin/element-icon/icon.less"></style>
<style lang="less">
  .el-table__header col[name="gutter"] {
    display: table-cell !important;
  }
  // 滚动条整体部分
  ::-webkit-scrollbar {
    width: 3px; //对垂直方向滚动条
    height: 3px; //对水平方向滚动条
  }

  //滚动的滑块
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(#909399,0.3); //滚动条的颜色
  }

  //内层滚动槽
  ::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
</style>
